import {
    Backdrop,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogTitle,
} from "@mui/material";
import { useIsMutating } from "@tanstack/react-query";
import { useContext, useState } from "react";
import { AppContext } from "../../../AppContext";
import LogoutButton from "../../../components/LogoutButton";
import SimpleWidgetsHeader from "../../../components/SimpleWidgetsHeader/SimpleWidgetsHeader";
import SimpleWidgetsInput from "../../../components/SimpleWidgetsInput/SimpleWidgetsInput";
import { isRoleAdmin, isRolePos } from "../../../frappeConfig";
import {
    useCreateOpeningEntry,
    usePOSEntryCreateData,
    useSearchPOSOpening,
} from "../../../shared/hooks/usePOSData";
import { getCurrentDate } from "../../../utils/dateUtils";
import { useStyles } from "./styles";
import { enqueueSnackbar } from "notistack";

const OpeningCreateDialog = ({ dialogOpen, onConfirm }) => {
    const classes = useStyles();
    const { globalState, userInfo, company, posProfile } =
        useContext(AppContext);
    const createPOSOpeningEntryMutation = usePOSEntryCreateData();
    const createOpeningEntryMutation = useCreateOpeningEntry();

    const { refetch: refetchOpeneningEntries } = useSearchPOSOpening({
        user: userInfo.name,
    });

    const [openingBalance, setOpeningBalance] = useState("");

    const [confirmationDialog, setConfirmationDialog] = useState(false);

    const isMutatin = useIsMutating();

    const permessionAllowed =
        userInfo.name == "Administrator" ||
        isRolePos(userInfo.role_profile_name) ||
        isRoleAdmin(userInfo.role_profile_name);

    const handleChange = (value) => {
        if (/^[0-9]*$/.test(value)) {
            setOpeningBalance(value);
        }
    };

    const handleSave = (event) => {
        event.preventDefault();
        // Perform necessary actions with the form data
        setConfirmationDialog(false);

        let cashValue = 0.0;

        try {
            cashValue = Number(openingBalance);
            if (isNaN(cashValue) || cashValue <= 0) {
                cashValue = 0.0;
            }
        } catch (err) {
            enqueueSnackbar("Please enter a valid cash value", {
                variant: "error",
            });
            return;
        }

        const loggedInUser = userInfo.name;

        const entryName = "new-pos-opening-entry-3";
        const childEntryName = "new-pos-opening-entry-detail-4";

        const another = {
            docstatus: 1,
            doctype: "POS Opening Entry",
            name: entryName,
            __islocal: 1,
            // "__unsaved": 0,
            owner: loggedInUser,
            status: "Open",
            posting_date: getCurrentDate(),
            set_posting_date: 0,
            company: company.company_name,
            balance_details: [
                {
                    docstatus: 2,
                    doctype: "POS Opening Entry Detail",
                    name: childEntryName,
                    __islocal: 1,
                    __unsaved: 1,
                    owner: loggedInUser,
                    opening_amount: cashValue,
                    parent: entryName,
                    parentfield: "balance_details",
                    parenttype: "POS Opening Entry",
                    idx: 1,
                    mode_of_payment: "Cash",
                },
            ],
            pos_profile: posProfile.name,
            period_start_date: getCurrentDate(),
            user: loggedInUser,
        };

        createOpeningEntryMutation.mutate(
            {
                company: company.company_name,
                pos_profile: posProfile.name,
                balance_details: another.balance_details,
            },
            {
                onSuccess: () => {
                    refetchOpeneningEntries();
                    if (onConfirm) onConfirm();
                },
            }
        );

        // createPOSOpeningEntryMutation.mutate(
        //     {
        //         branchId: globalState.branchName,
        //         formData: another,
        //     },
        //     {
        //         onSuccess: () => {
        //             refetchOpeneningEntries();
        //             if (onConfirm) onConfirm();
        //         },
        //     }
        // );
    };

    return (
        <Dialog className={classes.BackdropBlur} open={dialogOpen}>
            {isMutatin ? (
                <Backdrop open={true}>
                    {" "}
                    <CircularProgress />
                </Backdrop>
            ) : (
                <div className={classes.AddExtraWidget}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "8px 8px 0 8px",
                        }}
                    >
                        <LogoutButton />
                    </div>
                    {permessionAllowed ? (
                        <>
                            <div className={classes.AddPaymentWidget}>
                                <div
                                    className={
                                        classes.SmallTablePlaceholderWrapper
                                    }
                                >
                                    <SimpleWidgetsHeader title="INITIAL CASH VALUE" />
                                </div>
                                <div className={classes.Container}>
                                    <SimpleWidgetsInput
                                        value={openingBalance}
                                        onChange={handleChange}
                                        label="Cash Value"
                                        onKeyDown={(e) => {
                                            e.key === "Enter" &&
                                                setConfirmationDialog(true);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={classes.Actions}>
                                <Button
                                    onClick={() => setConfirmationDialog(true)}
                                >
                                    Save
                                </Button>
                            </div>
                        </>
                    ) : (
                        <div className={classes.SmallTablePlaceholderWrapper}>
                            <SimpleWidgetsHeader title="POS IN NOT OPEN" />
                            <div className={classes.Container}>
                                Please Contact Casheir or Supervisor
                            </div>
                        </div>
                    )}
                </div>
            )}

            <Dialog
                open={confirmationDialog}
                onClose={() => setConfirmationDialog(false)}
                aria-labelledby="opening-balance-confirmation"
                aria-describedby="opening-balance-confirmation"
            >
                <DialogTitle id="alert-dialog-title">
                    {`Opening Balance : ${openingBalance}`}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setConfirmationDialog(false)}>
                        Cancel
                    </Button>
                    <Button onClick={handleSave}>Confirm</Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    );
};

export default OpeningCreateDialog;
